import { useQuery } from "@tanstack/react-query";
import { getInviteDetailsBySlug } from "../api/accessRequest.api";

export const useLoadInviteDetails = (slug: string) => {
  const {
    data: inviteDetails,
    isLoading,
    isError,
  } = useQuery({
    queryFn: () => getInviteDetailsBySlug(slug),
    queryKey: ["invite-details", slug],
    enabled: !!slug,
    refetchOnWindowFocus: true,
  });

  return {
    inviteDetails,
    isLoading,
    isError,
  };
};

